import React, { Children } from 'react';
import './style/layaouts.css';
import { motion } from "framer-motion"

export const LayoutContainer = ({ children, styles_element }) => {
  return (
    <div className='containter_father_layout' style={styles_element}>
        {children}
    </div>
  )
}

export const LayoutRow = ({ children, styles }) => {
    return (
      <div className='row_layout' style={styles}>
          {children}
      </div>
    )
}

export const LayoutCol = ({ children }) => {

  const variants = {
    hidden: { opacity: 0, x: '-30%'},
    visible: { opacity: 1, x: 0},
  }

  return (
    <motion.div className='col_layout'
    initial='hidden'
    animate='visible'
    variants={variants}
    transition={{ duration: 0.5 }}
    >
        {children}
    </motion.div>
  )
}
